import { INSERT_WORKGROUP_MENU, UPDATE_WORKGROUP_MENU, GET_WORKGROUP_MENU, DELETE_WORKGROUP_MENU } from 'redux/admin-constants';

const initialState = { 
  workGroupMenuData:[],
}

const reducer = (state = initialState,  action) => {
const {
  type,
  payload
} = action;

switch (type) {

  case GET_WORKGROUP_MENU: {
    return {
      ...state,
      workGroupMenuData: payload,
    }
  }

  case INSERT_WORKGROUP_MENU: {
    return { ...state, workGroupMenuData:[payload, ...state.workGroupMenuData] }
  }

  case UPDATE_WORKGROUP_MENU: {
    return {
      ...state, 
      workGroupData:
       state.workGroupMenuData.map(item => item.workgroupmenuid === payload.workgroupmenuid ? 
        { ...item, ...payload} : item 
      )
    }
  }

  case DELETE_WORKGROUP_MENU:
    return { ...state, 
        workGroupMenuData: state.workGroupMenuData.filter(item => item.workgroupmenuid !== payload.workgroupmenuid)
  }

  default:
    return state;
  }
}

export default reducer;